import { ReactNode, useEffect } from 'react';
import { useDispatch } from 'react-redux';

// import useCheckNative from '../../hooks/utils/useCheckNative';
// import { appStore, isStandaloneMode } from '../../utils/os.utils';
import { setNativeApp } from '../native/native.slice';

const NativeWrapper = ({ children }: { children: ReactNode }) => {
  const dispatch = useDispatch();

  // Set webview ready flag
  (window as any).isWebviewReady = true;
  // const isNativeApp = useCheckNative();
  // const isEmbeddedApp = isNativeApp || isStandaloneMode;

  // Handle native app detection
  useEffect(() => {
    const handler = (e: Event) => {
      sessionStorage.setItem(
        'isNativeApp',
        JSON.stringify((e as CustomEvent<boolean>).detail)
      );
      dispatch(setNativeApp((e as CustomEvent<boolean>).detail));
    };

    window.addEventListener('native-ready', handler);
    return () => window.removeEventListener('native-ready', handler);
  }, [dispatch]);
  // if (!isEmbeddedApp) {
  //   appStore();
  // }
  return <>{children}</>;
};

export default NativeWrapper;
